import styled from "styled-components";
import {
  mediaMaxWidth,
  mediaMaxHeight,
} from "../../utils/mediaQueriesTemplate";
import zIndexTypes from "../../../theme/zIndexTypes";

export const Wrapper = styled.div``;

export const ModalTrigger = styled.div`
  margin: 0 10px;
  cursor: pointer;

  svg {
    font-size: 1.15em;
  }
`;

export const ModalBackdrop = styled.div`
  background-color: rgba(0, 0, 0, 0.6);
  height: 100vh;
  width: 100vw;
  position: fixed;
  left: 0;
  top: 0;
  z-index: ${zIndexTypes.modal};
  display: flex;
  justify-content: center;
  align-items: center;

  ${mediaMaxHeight.phone`
    align-items: unset;
  `}

  ${mediaMaxWidth.tablet`
    align-items: unset;
  `}
`;

export const ModalWrapper = styled.div`
  background-color: #ffffff;
  border-radius: 8px;
  width: 700px;
  z-index: ${zIndexTypes.modal};
  padding: 10px 20px;
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
  overflow: hidden;
  color: #565656;

  ${mediaMaxWidth.tablet`
    top: 10px;
    width: calc(100vw - 20px);
    padding: 20px;
  `}
`;

export const CloseButton = styled.div`
  cursor: pointer;
  position: absolute;
  right: 30px;
  top: 25px;

  svg {
    color: #a0a0a0;
    font-size: 1.2em;
    transition: 0.1s ease-in-out;

    &:hover {
      color: #402680;
    }
  }

  ${mediaMaxWidth.tablet`
    right: 20px;
    top: 15px;

    svg {
      font-size: 1.5em;
    }
  `}
`;

export const Body = styled.div`
  color: #565656;
  padding: 5px 10px;
  display: flex;
`;

export const Row = styled.div`
  margin: 10px 0 50px 0;

  &:last-of-type {
    margin: 10px 0 20px 0;
  }
`;

export const Column = styled.div`
  display: flex;
  flex: 1;
`;

export const Top = styled.div`
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid #d8d8d8;
  padding: 5px 10px;

  ${mediaMaxWidth.tablet`
    display: unset;
    width: 50%;
    float: left;
    line-height: 2em;
    border-bottom: none;
    padding: 0px;
  `}

  ${mediaMaxWidth.smallPhone`
    width: 60%;
  `}
`;

export const ColumnTitle = styled.div`
  display: flex;
  flex: 1;
  font-weight: 600;
  font-size: 1em;

  ${mediaMaxWidth.tablet`
    font-size: 1.1em;
  `}
`;

export const Bottom = styled.div`
  display: flex;
  flex-direction: row;
  padding: 10px;

  ${mediaMaxWidth.tablet`
    display: unset;
    width: 30%;
    float: right;
    font-size: 1em;
    line-height: 2em;
    padding: 0px;
  `}

  ${mediaMaxWidth.smallPhone`
    width: 25%;
  `}
`;

export const ColumnData = styled.div`
  display: flex;
  flex: 1;
  font-size: 2em;
  font-weight: 400;

  ${mediaMaxWidth.tablet`
    font-size: 1.1em;
    font-weight: 400;
  `}
`;
